module.exports = __webpack_public_path__ + "f3188469d604a1697e5ebaa7fa5acf27.png";